import { Dispatcher } from 'flux';

var dispatcher = new Dispatcher;
/**
 * Singleton Dispatcher for App messages
 */
export default dispatcher
